@let controlValue = control();

<mat-form-field class="list-filter-form-field">
  <mat-label>{{ label() }}</mat-label>
  <mat-select [formControl]="controlValue">
    @for (language of LanguageCodes; track language) {
      <mat-option [value]="language">{{
        `${coreI18nScope}LANGUAGE_CODE.${language}` | transloco
      }}</mat-option>
    }
  </mat-select>
  <cappus-filter-clear-button matSuffix [control]="controlValue" />
</mat-form-field>
